module.exports = __webpack_public_path__ + "img/icon-simplex-light.f38d01ea.png";